module.exports = __webpack_public_path__ + "static/media/sent.000e4d2e.svg";